import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';
import resources from '@core/Util/Mixins/resources';
import snowplow from '@modules/JourneyBuilder/snowplow';
import api from '@modules/JourneyBuilder/api';
import { bootstrapDangerGrowl } from '@core/Util/growler';

import VSelect from 'vue-select';
import SettingsItem from '../SettingsProperty';

const resolvePromise = (promise, callback) => {
    promise.then(
        (result) => {
            callback(result);
        },
        bootstrapDangerGrowl
    );
};

export default {
    components: {
        VSelect,
        SettingsItem
    },
    mixins: [permissionsMixin,resources],
    created() {
        const vm = this;

        //We don't want to update the property until the save button is clicked.
        vm.settings = Object.assign({}, vm.value);
        vm.newName = vm.name;
    },
    methods: {
        saveSettings() {
            snowplow.trackStructuredEvent(`changed-${this.type}-settings`);

            this.$emit('save', {
                config: this.settings,
                name: this.newName
            });
        },
        getJourneys(callback) {
            resolvePromise(api.getJourneys(), callback);
        },
        getTouchPoints(callback) {
            resolvePromise(api.getTouchpointTypes(), callback);
        },
        getAudiences(callback) {
            resolvePromise(api.getAudiences(), callback);
        }
    },
    computed: {
        brickType(){
            return this.brick.type;
        },
        
        type() {
            //Type is the last part of the component name. Used for snowplow event tracking.
            const nameParts = this.$options.name.split('-');
            return nameParts[nameParts.length-1];
        },
        
        brickId(){
            return this.brick.id;
        },

        value(){
            return this.brick.config;
        },
        
        name(){
            return this.brick.name;
        }
    },
    data() {
        return {
            settings: {},
            newName: this.brick.name
        };
    },
    props: {
        /**
         * @type {JourneyBrick}
         */
        brick: {
            type: Object,
            required: true
        }
    }
};